import Position from './Position.vue';
import AddSaleMixin from '../AddSaleMixin';

export default {
  props: ['action_id', 'id'],
  components: { Position },
  mixins: [AddSaleMixin],
  methods: {
    removePosition(index) {
      this.form.positions.splice(index, 1);
    },
    addPosition() {
      this.form.positions.push({
        article: null,
        product_id: null,
        model_photos: [],
        number_photos: [],
      });
    },
    deletePosition(idx) {
      this.positions.splice(idx, 1);
    },
    /**
     * Установка предзагруженных значений при редактировании продажи.
     */
    setDataPreload() {
      const app = this;
      this.form = { ...app.sale };
      if (app.sale.address) {
        this.addresses.push({
          value: app.sale.address,
        });
      }
      if (app.sale.city) {
        this.cities.push({ ...app.sale.city });
      }
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(is_draft = false) {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'sales/api/sale/create';

      const sale = {
        register_type: 'web',
        ...this.form,
        is_draft,
        profile_id: this.user.profile_id,
        action_id: this.action_id,
      };

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
        sale.register_type = 'web';
      }

      app.$store.getters.axl
        .post(restURL, sale)
        .then(() => {
          this.$store.dispatch('sales/GetSales', {
            profile_id: this.$store.state.user.profile_id,
          });
          app.$router.push('/sales/installation');
          app.$store.dispatch('ShowInfo', 'Монтаж отправлен на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          this.submitIsProcessing = false;
        });
    },
  },
  mounted() {
    if (this.saleID !== 'null') {
      this.setDataPreload();
    } else {
      this.addPosition();
    }
  },
};
